var slInfo = document.querySelector('.b-sl-wrapper__banner-title')
var slInfoContent = document.querySelector('.b-sl-wrapper__content-banner')
var baner = document.querySelector('.b-sl-wrapper__banner')


function classToggle() {
    slInfoContent.classList.toggle('show');
    baner.classList.toggle('show');
}

if(slInfo){
    slInfo.addEventListener('click', classToggle);
}






// WEBPACK FOOTER //
// ./src/js/pages/object/openghours.js